import {
  Button,
  ButtonProps,
  Text,
  TextProps,
  TooltipProps,
} from '@chakra-ui/react'
import { forwardRef } from 'react'
import { Link, LinkProps } from 'react-router-dom'

import { Tooltip } from '../Tooltip/Tooltip'

export const SidenavTooltip = forwardRef((props: TooltipProps, ref) => (
  <Tooltip ref={ref} placement="right" {...props} />
))

export const MenuSubheader = ({ children }: TextProps) => (
  <Text
    color="presets.neutral.60"
    fontSize="12px"
    fontWeight="700"
    lineHeight="20px"
    padding="16px 20px 4px"
    letterSpacing="0.2px"
    whiteSpace="nowrap"
    textTransform="uppercase"
  >
    {children}
  </Text>
)

export const SidenavButton = forwardRef(
  ({ children, to, ...props }: ButtonProps & LinkProps, ref) => (
    <Button
      ref={ref}
      as={Link}
      /**
       * State is checked in the router and used to help identify the
       * uniqueness of the link. This is useful when clicking a sidebar
       * link back to the SAME page. Without being able to use the state
       * as part of a unique key for the route. The url query string will
       * clear, but the page component will not unmount. This results in
       * not being able to clear state when clicking on sidebar links.
       *
       * So, without another workaround. Ensure that a unique time based
       * value is passed along in state.
       */
      state={{ time: new Date().getTime() }}
      to={props.isDisabled ? '#' : to}
      border="1px solid"
      borderColor="transparent"
      backgroundColor="transparent"
      borderRadius="34px"
      color="presets.neutral.0"
      fontWeight="500"
      justifyContent="flex-start"
      height="40px"
      letterSpacing="0.2px"
      paddingY="12px"
      paddingX="20px"
      width="100%"
      _disabled={{
        cursor: 'pointer',
        color: 'presets.neutral.0',
        fontStyle: 'italic',
        opacity: 0.5,
        svg: {
          fill: 'presets.neutral.0',
        },
      }}
      _hover={{
        bg: props.isActive ? props._active?.backgroundColor : '#FFFFFF29',
        color: props.isActive ? props._active?.color : 'presets.neutral.0',
      }}
      {...props}
    >
      {children}
    </Button>
  ),
)
